import { useCallback } from "react";
import { createSession } from "../api/session.js";
export const useAuth = () => {
    const handleAuth = useCallback(async (data) => {
        const { email, password } = data;
        const sessionResponse = await createSession({
            email,
            password,
        });
        return sessionResponse;
    }, [createSession]);
    return { handleAuth };
};
